<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first dedication-content"><i>For my beloved cousins,</i></p>
<p class="subsq blockquote-content blockquote-content-prose blockquote-position-last dedication-content"><i>Dick, Bob, Linda, Suzanne, and Debbie</i></p>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7ea59a18